// IMPORTS
import React, { useState } from "react";
import Card from "@mui/material/Card";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import CardContent from "@mui/material/CardContent";
import { Grid } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import CustomInput from "./CustomInput";
import Avatar from "@mui/material/Avatar";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import Badge from "@mui/material/Badge";
import SendIcon from '@mui/icons-material/Send';
import { sendPasswordResetEmail, updateProfile } from "firebase/auth";
import { useAuth } from "../../shared/context/AuthContext";

//APP
export default function SettingsCard() {

  const { auth, user } = useAuth();
  const [ profile, setProfile] = useState(null)

  const changeField = (event) => {
    setProfile({ ...profile, [event.target.name]: event.target.value });
    if (event.target.name == "name") {
      user.displayName = event.target.value
    }
    edit.disabled = false
    update({ ...edit });
  };

  //BUTTON STATES
  const [edit, update] = useState({
    required: true,
    disabled: true,
    isEdit: true
  });

  // EDIT -> UPDATE
  const changeButton = () => {
    edit.disabled = !edit.disabled;
    update({ ...edit });
  };

  //RETURN
  return (
    <Card variant="outlined" sx={{ height: "100%", width: "100%" }}>
      {/* MAIN CONTENT CONTAINER */}
      <form>
        <CardContent
          sx={{
            p: 3,
            textAlign: { xs: "center", md: "start" }
          }}
        >
          {/* FIELDS */}
          {/* <Badge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            badgeContent={
              <PhotoCameraIcon
                sx={{
                  border: "5px solid white",
                  backgroundColor: "#ff558f",
                  borderRadius: "50%",
                  padding: ".2rem",
                  width: 35,
                  height: 35
                }}
              ></PhotoCameraIcon>
            }
          >
            <Avatar
              sx={{ width: 100, height: 100, mb: 1.5 }}
              src={ user?.photoURL }
            ></Avatar>
          </Badge> */}
          <Grid container columns={16} rowSpacing={2}>
            {/* ROW 1: NAME */}
            <Grid size={8} pt={3}>
              <CustomInput
                id="name"
                name="name"
                value={user?.displayName}
                onChange={changeField}
                title="Name"
                req={true}
              ></CustomInput>
            </Grid>
            <Grid size={8}>
            </Grid>

              {/* ROW 2: EMAIL */}
              <Grid size={8}>
                <CustomInput
                  type="email"
                  id="email"
                  name="email"
                  value={user?.email}
                  onChange={changeField}
                  title="Email Address"
                  req={true}
                  dis={true}
                ></CustomInput>
              </Grid>
              <Grid size={8}>
              </Grid>

              {/* ROW 3: PASSWORD */}
              <Grid size={8} pt={1}>
                <Button variant="text"
                        endIcon={<SendIcon />}
                        style={{ padding: 0 }}
                        sx={{ '&.MuiButton-root:hover':{bgcolor: 'transparent'} }}
                        onClick={() => {
                          if (user !== null) {
                            sendPasswordResetEmail(auth, user.email)
                            .then(() => {
                              // Password reset email sent!
                              alert('An email to reset your password has been sent to your address. Please check your inbox (and spam folder if needed).');
                            })
                            .catch((error) => {
                              const errorCode = error.code;
                              const errorMessage = error.message;
                              alert('An error reseting your password has occurred !')
                            });
                          }
                        }}>
                        Send password reset email
                </Button>
              </Grid>
              <Grid size={8}>
              </Grid>
              </Grid>

              {/* BUTTON */}
              <Grid pt={4} pb={3}
                container
                justifyContent={{ xs: "center" }}
                item
                xs={6}
              >
                <Button
                  sx={{ width: 1/4,
                        "&.Mui-disabled": {
                          background: "#727272",
                          color: "#ffffff"
                        }
                  }}
                  component="button"
                  size="small"
                  variant="contained"
                  disabled={edit.disabled}
                  onClick={() => {
                    if (user !== null) {
                      updateProfile(user, {
                        displayName: profile["name"]
                      }).then(() => {
                        // Profile updated!
                        alert('Your profile has been updated !')
                        changeButton()
                      }).catch((error) => {
                        // An error occurred
                        //alert('An error updating your profile has occurred !')
                      });
                    }
                  }}>
                  Update
                </Button>
              </Grid>
        </CardContent>
      </form>
    </Card>
  );
}
